export const IntegrationsActions = {
  SUBMITTING: '[integrations] submitting',
};

const initialState = {
  submitting: false,
};

const integrations = (state = initialState, action) => {
  switch (action.type) {
    case IntegrationsActions.SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };

    default:
      break;
  }

  return state;
};

export default integrations;
